/* (ignored) */


//////////////////
// WEBPACK FOOTER
// min-document (ignored)
// module id = 28
// module chunks = 0